import { languageTuples } from "src/utils/util";
import { Select } from "src/components/Form/select";
import { UserLangCode } from "src/utils/util.types";
import React from "react";

type Props = {
  onChange: (langCode: UserLangCode) => void;
};

export const StatsFilter: React.FC<Props> = ({ onChange }) => {
  return (
    <div className="grid grid-cols-2 gap-x-4 items-center mb-6">
      <h1 className="text-2xl font-bold text-gray-900">Statistics</h1>

      <div className="flex justify-end">
        <Select
          className="w-64"
          options={languageTuples}
          label="Language"
          includeOption="All Spaces"
          getOptionValue={(tuple) => tuple[0]}
          getOptionLabel={(tuple) => tuple[1]}
          onChange={(val) => onChange(val as UserLangCode)}
        />
      </div>
    </div>
  );
};
